import { Component, h, Node, WriteOnlyRef } from "@lukekaalim/act";
import { BufferGeometry, Euler, Material, Mesh, Object3D, Quaternion, Vector2, Vector3, Vector3Like } from "three";
import { a3 } from "@lukekaalim/act-three";

export type ObjectCloneProps = {
  tilePosition?: Vector2 | null,

  target: Object3D,

  ref?: WriteOnlyRef<Object3D | null>,

  position?: Vector3Like,
  rotation?: Euler,
  quaternion?: Quaternion,
  
  scale?: Vector3Like,

  overrideRoot?: {
    material?: Material
    geometry?: BufferGeometry,
  },

  material?: Material | null,

  depthLimit?: number,
  renderChildren?(target: Object3D, depthLimit: number): Node,
};

export const ObjectClone: Component<ObjectCloneProps> = ({
  tilePosition,
  target,
  ref,
  position,
  rotation,
  material,
  scale,
  renderChildren = child => h(ObjectClone, { target: child, depthLimit: depthLimit - 1, material, tilePosition }),
  depthLimit = Number.POSITIVE_INFINITY
}) => {
  const children = (depthLimit < 1)
    ? null
    : target.children.map(child => renderChildren(child, depthLimit));

  if (target instanceof Mesh) {
    return h(tilePosition ? a3.tile : a3.mesh, {
      name: target.name,
      ref,

      tilePosition: tilePosition || new Vector2(),

      geometry: target.geometry,
      material: material || target.material,

      position: position || target.position,
      rotation,
      quaternion: !rotation && target.quaternion || undefined,
      scale: scale ? new Vector3().copy(scale) : target.scale
    }, children)
  }
  
  return h(a3.group, {
    name: target.name,
    ref,

    position: position || target.position,
    quaternion: !rotation && target.quaternion || undefined,
    rotation,
    scale: target.scale,
  }, children)
}